import { observer } from "mobx-react-lite";
import { JSX } from "react";
import { useDragging } from "../contexts/DraggingContext";
import type AircraftModel from "../model/AircraftModel";
import { cwpStore } from "../state";
import { formatSpeed } from "../utils";
import {
	Altitude,
	AssignedBearing,
	CallSign,
	NextACCFlightLevel,
	NextNav,
	NextSectorFL,
	VerticalSpeedIcon,
	WarningIcon,
} from "./AircraftLabelParts";

export default observer(function AircraftContentSmall(properties: {
	aircraft: AircraftModel;
	flightColor: string;
	width: number;
}) {
	const { isDragging } = useDragging();
	const { aircraft, flightColor } = properties;
	const { lastKnownSpeed } = aircraft;

	const openSpeedPopup = (): void => {
		if (isDragging) {
			return;
		}
		cwpStore.openChangeSpeedForAircraft(aircraft.aircraftId);
	};

	const displayBearing = (): JSX.Element | null => {
		return (
			<>
				<NextNav
					aircraft={aircraft}
					showInUnsetMode={false}
					showPlaceholderWhenRerouted={false}
				/>
				<AssignedBearing
					aircraft={aircraft}
					showPlaceholderWhenNotRerouted={false}
				/>
			</>
		);
	};

	return (
		<div
			style={{ color: flightColor }}
			className={
				aircraft.degreased ? "font-normal font-mono" : "font-bold font-mono"
			}
		>
			{/* Line 0 */}
			<div>
				<span
					onClick={openSpeedPopup}
					className="hover:outline-2 hover:outline-white cursor-pointer"
				>
					{formatSpeed(lastKnownSpeed)}
				</span>
				<span className="ml-1">&nbsp;&nbsp;</span>
			</div>
			{/* Line 1 */}
			<div>
				<CallSign flightColor={flightColor} aircraft={aircraft} />
				<span className="ml-1"></span>
				<WarningIcon aircraft={aircraft} skipNone={true} />
			</div>
			{/* Line 2 - clearance in RESP state*/}
			<div>
				<Altitude aircraft={aircraft} />
				<span className="ml-0.5"></span>
				<VerticalSpeedIcon aircraft={aircraft} />
				<span className="ml-0.5"></span>
				<NextACCFlightLevel aircraft={aircraft} hideIfMatchesAltitude={true} />
				<span className="ml-0.5"></span>
				{/* <BearingChangeIcon aircraft={aircraft} />
				<span className="ml-0.5"></span> */}
				{displayBearing()}
			</div>
			{Math.round(aircraft.lastKnownAltitude) / 10 !==
				Number.parseInt(aircraft.nextSectorFL) && (
				<div>
					<NextSectorFL aircraft={aircraft} />
				</div>
			)}
		</div>
	);
});
